var perMonthPayment = function (amount, termInMonth, rate) {
    if ([amount, termInMonth, rate].some(function (v) { return Number.isNaN(v); }) || termInMonth === 0) {
        return 0;
    }
    var percentRate = rate / 100 / 12;
    return Math.trunc((amount * percentRate * Math.pow((1 + percentRate), termInMonth)) / (Math.pow((1 + percentRate), termInMonth) - 1));
};

export { perMonthPayment };
//# sourceMappingURL=calculating.js.map
